export default __webpack_public_path__ + "static/media/high-five-hands.cd8f1211.svg";